export default __webpack_public_path__ + "static/media/confetti-BL.a0602d68.svg";